import { formatReservationDate, isWeb } from "@stepapp/core";
import { ReservationStatus } from "@stepapp/core/apiTypes";
import { useRouter } from "expo-router";
import React, { useCallback } from "react";
import { StyleSheet } from "react-native";

import { Block, Button, Typography, palette, useBreakpoints } from "@stepapp/ui";
import { useTranslation } from "react-i18next";
import { useFindServicesForReview } from "../../src/hooks";

const ServiceBanner = () => {
  const { navigate } = useRouter();
  const { md } = useBreakpoints();
  const { t } = useTranslation();
  const { servicesForReview, servicesToRetryPayment } = useFindServicesForReview();

  const order = servicesToRetryPayment?.[0] || servicesForReview?.[0];

  const reservationDate = formatReservationDate(order?.startDate || "", "HH:mm, dd MMMM yyyy");

  const paymentFailed = order?.status === ReservationStatus.PaymentFailed;

  const navigateToCalendar = useCallback(() => {
    return navigate("/calendar/");
  }, [navigate]);

  const navigateToRating = useCallback(() => {
    if (order?.status === ReservationStatus.CustomerReview) {
      return navigate(`/calendar/${order?.id}/rating/confirmation`);
    }
    return navigate(`/calendar/${order?.id}/rating`);
  }, [order, navigate]);

  if (!order) return null;

  return (
    <Block
      alignCenter
      justifySpace
      row
      marginHorizontal={md ? -1.5 : -2.5}
      paddingHorizontal={2.5}
      paddingVertical={isWeb ? 2 : 1}
      style={paymentFailed ? styles.retryPayment : styles.leaveReview}
    >
      <Block flex={1} marginRight={1}>
        {paymentFailed ? (
          <Typography variant="newH4">{t("screens.dashboard.couldntProcessPayment")}</Typography>
        ) : (
          <>
            <Typography variant="lightLabel">{reservationDate}</Typography>
            <Typography decoration="capitalize" variant="newH4">
              {order?.bundle?.name}
            </Typography>
          </>
        )}
      </Block>
      <Button
        label={paymentFailed ? t("common.update") : t("screens.serviceRating.leaveRating")}
        onPress={paymentFailed ? navigateToCalendar : navigateToRating}
        type="primary"
        variant="small"
      />
    </Block>
  );
};

export default React.memo(ServiceBanner);

const styles = StyleSheet.create({
  leaveReview: {
    backgroundColor: palette.common.paleViolet,
  },
  retryPayment: {
    backgroundColor: palette.common.wrongPink,
  },
});
